import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Form, Input, Checkbox, Button, Tab, Select } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import CustomFieldType, { CustomFieldTypeOptions } from "~/constants/UiMeet3d/GreetingBot/CustomFieldType";

const GreetingBotAdvancedFormBuilder = observer(
  ({
    t,
    isModal,
    customFieldBindInput,
    customFieldModel,
    customFieldSetProperty,
    canSaveCustomField,
    onCustomFieldSave,
    saveButtonLabel,
  }) => {
    // custom  field stuff
    const showValue = customFieldModel.type === CustomFieldType.TEXTAREA;
    const isFormField =
      [
        CustomFieldType.INPUT_TEXT,
        CustomFieldType.INPUT_EMAIL,
        CustomFieldType.TEXTAREA,
        CustomFieldType.CHECKBOX,
      ].indexOf(customFieldModel.type) !== -1;

    return (
      <Form className="greeting-bot-form-wrap">
        <Form.Field
          control={Select}
          {...customFieldBindInput("type")}
          value={customFieldModel.type}
          onChange={(_event, { value }) => customFieldSetProperty("type", value)}
          label="Type"
          options={CustomFieldTypeOptions.map(option => {
            return {
              key: option.key,
              value: option.value,
              text: t(option.translationText),
            };
          })}
        />
        <h4>{t("label")}</h4>
        <Tab
          className="field"
          panes={[
            {
              menuItem: t("english"),
              render: () => (
                <Tab.Pane>
                  <Form.Field
                    control={Input}
                    label={t("label")}
                    {...customFieldBindInput("label_en")}
                    value={customFieldModel.label_en}
                  />
                </Tab.Pane>
              ),
            },
            {
              menuItem: t("french"),
              render: () => (
                <Tab.Pane>
                  <Form.Field
                    control={Input}
                    label={t("label")}
                    {...customFieldBindInput("label_fr")}
                    value={customFieldModel.label_fr}
                  />
                </Tab.Pane>
              ),
            },
          ]}
        />
        {showValue && (
          <>
            <h4>{t("clientPanelMisc:defaultValue")}</h4>
            <Tab
              className="field"
              panes={[
                {
                  menuItem: t("english"),
                  render: () => (
                    <Tab.Pane>
                      <Form.Field
                        control={Input}
                        label={t("clientPanelMisc:defaultValue")}
                        {...customFieldBindInput("value_en")}
                        value={customFieldModel.value_en}
                      />
                    </Tab.Pane>
                  ),
                },
                {
                  menuItem: t("french"),
                  render: () => (
                    <Tab.Pane>
                      <Form.Field
                        control={Input}
                        label={t("clientPanelMisc:defaultValue")}
                        {...customFieldBindInput("value_fr")}
                        value={customFieldModel.value_fr}
                      />
                    </Tab.Pane>
                  ),
                },
              ]}
            />
          </>
        )}
        {isFormField && (
          <Form.Field
            control={Checkbox}
            checked={customFieldModel.mandatory}
            label={`${t("required")}?`}
            value=""
            onChange={() => customFieldSetProperty("mandatory", !customFieldModel.mandatory)}
          />
        )}
        <br />
        {!isModal && (
          <Button primary disabled={!canSaveCustomField} onClick={() => onCustomFieldSave()}>
            {saveButtonLabel}
          </Button>
        )}
      </Form>
    );
  },
);

GreetingBotAdvancedFormBuilder.propTypes = {
  t: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
  saveButtonLabel: PropTypes.string,
  canSaveCustomField: PropTypes.bool,
  onCancel: PropTypes.func,
  bindInput: PropTypes.func.isRequired,
  model: PropTypes.shape({
    action_form_title_en: PropTypes.string,
    action_form_title_fr: PropTypes.string,
  }),
  customFieldBindInput: PropTypes.func.isRequired,
  customFieldModel: PropTypes.shape({
    type: PropTypes.string,
    label_en: PropTypes.string,
    label_fr: PropTypes.string,
    value_en: PropTypes.string,
    value_fr: PropTypes.string,
    mandatory: PropTypes.bool,
  }),
  customFieldSetProperty: PropTypes.func.isRequired,
  onCustomFieldSave: PropTypes.func,
};

GreetingBotAdvancedFormBuilder.defaultProps = {
  saveButtonLabel: "Add Field",
};

export default withTranslation()(GreetingBotAdvancedFormBuilder);
